var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"data-label"},[_c('b-col',{staticClass:"text-left ml-0 mr-0 headLabel",attrs:{"cols":"6"}},[_vm._v(_vm._s(_vm.labelName))]),_c('b-col',{class:_vm.labelRight == true ? 'text-right' : 'text-left',attrs:{"cols":"6"}},[_vm._v(_vm._s(_vm.data == null || _vm.data == '' ? 'N/A' : _vm.data))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }